import { useQuery } from '@tanstack/react-query';
import { marketing } from '@/lib/supabase/marketing';

/**
 * Returns minutes since the live Petpooja sales feed last synced.
 * Drives the "Live · Nm" pulse in the topbar.
 *
 * Reads marketing.data_freshness_v (max synced_at across petpooja_orders /
 * petpooja_sales). The previous source, marketing.sales_daily, was retired
 * ~30 May 2026 when sales moved to the real-time pipeline, so it made the
 * badge read ~66 days stale while sales were in fact current.
 */
export function useDataFreshness() {
  return useQuery({
    queryKey: ['data-freshness'],
    queryFn: async (): Promise<number | null> => {
      const { data, error } = await marketing
        .from('data_freshness_v')
        .select('last_synced')
        .limit(1);
      if (error) throw error;
      const ts = data?.[0]?.last_synced;
      if (!ts) return null;
      const minutes = Math.max(0, Math.round((Date.now() - new Date(ts).getTime()) / 60_000));
      return minutes;
    },
    refetchInterval: 60_000,
    staleTime: 30_000,
  });
}
